import request from '@/utils/request'
// 获取场地信息
export function qryFieldInfo(query) {
  return request({
    url: '/api/fieldInfo/qryFieldInfo',
    method: 'post',
    params: query
  })
}
// 获取会员信息
export function qryMemberUser(query) {
  return request({
    url: '/api/fieldInfo/qryMemberUser',
    method: 'post',
    params: query
  })
}
// 获取员工信息
export function qryStaff(query) {
  return request({
    url: '/api/fieldInfo/qryStaff',
    method: 'post',
    params: query
  })
}
// 查询维护人员
export function qryDefend(query) {
  return request({
    url: '/api/fieldInfo/qryDefend',
    method: 'post',
    params: query
  })
}
// 查询柜子管理员
export function qryCabinet(query) {
  return request({
    url: '/api/fieldInfo/qryCabinet',
    method: 'post',
    params: query
  })
}
// 新增场地
export function txField(query) {
  return request({
    url: '/api/fieldInfo/txField',
    method: 'post',
    data: query
  })
}
// 删除场地员工
export function delFieldUser(query) {
  return request({
    url: '/api/fieldInfo/delFieldUser',
    method: 'post',
    params: query
  })
}
// 获取场地下的设备
export function qryDevice(query) {
  return request({
    url: '/api/fieldInfo/qryDevice',
    method: 'post',
    params: query
  })
}
// 上传图片
export function uploadImg(query) {
  return request({
    url: '/api/common/uploadImg',
    method: 'post',
    data: query
  })
}

// POST /api/fieldInfo/updateFieldState 修改场地状态 禁用启用
export function updateFieldState(query) {
  return request({
    url: '/api/fieldInfo/updateFieldState',
    method: 'post',
    params: query
  })
}

// GET /api/fieldInfo/qryFieldDetail 查询场地详情
export function qryFieldDetail(query) {
  return request({
    url: '/api/fieldInfo/qryFieldDetail',
    params: query
  })
}

/**
 *POST /api/fieldInfo/qryFieldUserIncrease 查询场地新用户增长量
 * @param {*} params
 * @returns
 */
export function qryFieldUserIncrease(params) {
  return request({
    url: '/api/fieldInfo/qryFieldUserIncrease',
    method: 'post',
    params
  })
}

/**
 *POST /api/fieldInfo/clearFieldUserIncrease 清理场地新用户增长量
 * @param {*} params
 */
export function clearFieldUserIncrease(params) {
  return request({
    url: '/api/fieldInfo/clearFieldUserIncrease',
    method: 'post',
    params
  })
}
